import { render, staticRenderFns } from "./DanhSachGroupKhongThuocNguoiDung.vue?vue&type=template&id=12bd8e39&"
import script from "./DanhSachGroupKhongThuocNguoiDung.vue?vue&type=script&lang=js&"
export * from "./DanhSachGroupKhongThuocNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports